import { AdobeAnalyticsUtil } from './AdobeAnalyticsUtil.js';
import { sendAbTestingHit } from '/Foundation/ABTesting/code/Views/Foundation/ABTesting/abTestingClient.js';
export const Analytics_AddToCart = (() => {
  const addToCartButtonClass = '.tag-manager-add-to-cart-button';
  return {
    ApplyAddToCartButtonEvent: () => {
      try {
        // Keep track of buttons avoid multiples of  events on the same button
        window.__adobeAtcBoundButtons = window.__adobeAtcBoundButtons || new WeakSet();
        const boundButtons = window.__adobeAtcBoundButtons;
        document.querySelectorAll(addToCartButtonClass).forEach((item) => {
          if (boundButtons.has(item)) return;
          boundButtons.add(item);
          item.addEventListener('click', () => {
            const trackingData = Analytics_AddToCart.GetTrackingDataFromElement(item);
            const variant = trackingData?.source ?? '';
            const subcategory = trackingData?.products?.[0]?.subcategory ?? '';
            const label = [variant, subcategory].filter(Boolean).join(',');
            sendAbTestingHit('Add_To_Cart_Clicked', label);
            if (!trackingData) return;
            AdobeAnalyticsUtil.DataLayer.TrackEvent('cart_addition', {
              add_to_cart_variant: trackingData.source,
              products: trackingData.products,
            });
          });
        });
      } catch (error) {}
    },
    GetAnalyticsDataFromUpsellButton: (item) => {
      var accessory = item.closest('.accessory');
      let data = accessory.querySelector('.analyticsData')?.dataset;

      let product = {
        id: data.productid,
        name: data.thuleproductname,
        price: data.price,
        colour: data.colorspecification,
        original_price: data.originalprice,
        over_category: data.overcategory,
        category: data.category,
        subcategory: data.subcategory,
        quantity: '1',
      };

      return {
        products: [product],
        source: 'add_to_cart_upselling',
      };
    },
    GetAnalyticsDataFromAccessoryPush: (item) => {
      var accessory = item.closest('.accessory-add-to-cart');
      let data = accessory.querySelector('.analyticsData')?.dataset;

      let product = {
        id: data.productid,
        name: data.thuleproductname,
        price: data.price,
        colour: data.colorspecification,
        original_price: data.originalprice,
        over_category: data.overcategory,
        category: data.category,
        subcategory: data.subcategory,
        quantity: '1',
      };

      return {
        products: [product],
        source: 'add_to_cart_accessory_push',
      };
    },
    GetTrackingDataFromSparePartObject: (sparePart) => {
      let product = {
        id: sparePart.ProductId,
        name: sparePart.Name,
        price: sparePart.Price,
        colour: sparePart.ColorSpecification,
        original_price: sparePart.Price,
        category: sparePart.Category,
        subcategory: sparePart.Subcategory,
        over_category: sparePart.OverCategory,
        quantity: '1',
      };
      return { products: [product], source: 'add_to_cart_sparepart' };
    },
    GetTrackingDataForExtranetSparePart: (sparePart, itemResponse, isKeysAndLocks) => {
      let product = {
        id: sparePart.ProductId,
        name: sparePart.Name,
        brand: sparePart.Brand,
        price: itemResponse?.UnformattedSalesPrice,
        original_price: itemResponse?.UnformattedSalesPrice,
        colour: sparePart.ColorSpecification,
        category: sparePart.Category,
        subcategory: sparePart.Subcategory,
        over_category: sparePart.OverCategory,
        quantity: '1',
        stock_status: isNaN(itemResponse.Availability) ? itemResponse.Availability : 'In stock',
      };

      let trackingObject = { products: [product] };

      if (isKeysAndLocks) {
        trackingObject.add_to_cart_variant = 'add_to_cart_keysandlocks';
      } else {
        trackingObject.add_to_cart_variant = 'add_to_cart_sparepart';
      }

      return trackingObject;
    },
    GetTrackingDataFromElement: (addToCartButtonElement) => {
      if (addToCartButtonElement.classList.contains('accessory-atc-button')) {
        const upsellData = Analytics_AddToCart.GetAnalyticsDataFromUpsellButton(addToCartButtonElement);
        return upsellData;
      }

      if (addToCartButtonElement.classList.contains('accessory-add-to-cart')) {
        const accessoryPushData = Analytics_AddToCart.GetAnalyticsDataFromAccessoryPush(addToCartButtonElement);
        return accessoryPushData;
      }

      const productContainer = addToCartButtonElement.closest('.product-add-to-cart');
      const adobeAnalyticsData = productContainer?.querySelector('.analyticsData')?.dataset;

      if (!adobeAnalyticsData) return null;

      let product = {
        id: adobeAnalyticsData.productid,
        name: adobeAnalyticsData.thuleproductname,
        price: adobeAnalyticsData.price,
        colour: adobeAnalyticsData.colorspecification,
        original_price: adobeAnalyticsData.originalprice,
        category: adobeAnalyticsData.category,
        subcategory: adobeAnalyticsData.subcategory,
        over_category: adobeAnalyticsData.overcategory,
        quantity: '1',
      };

      let source;
      if (adobeAnalyticsData.isbundle === 'True' && addToCartButtonElement.classList.contains('sticky'))
        source = 'add_to_cart_bundle_sticky';
      else if (adobeAnalyticsData.isbundle === 'True') source = 'add_to_cart_bundle';
      else if (addToCartButtonElement.classList.contains('sticky')) source = 'add_to_cart_pdp_sticky';
      else if (addToCartButtonElement.classList.contains('dbg_cart_btn')) source = 'add_to_cart_DBG';
      else source = 'add_to_cart_pdp';

      return {
        products: [product],
        source,
      };
    },
  };
})();
